import { combineReducers } from 'redux';

import { createRequestStateReducer } from 'src/store/helpers';

import { serviceSettingsActions } from './actions';

export const serviceSettingsReducer = combineReducers({
  globalServiceSetting: createRequestStateReducer(serviceSettingsActions.getGlobalServiceSetting),
});
